<template>
  <div class="config-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            v-model="paramKey"
            placeholder="参数名"
            style="width: 100%"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only"
          v-model="paramKey"
          placeholder="参数名"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('sys:config:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('sys:config:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              参数名
            </vs-th>
            <vs-th>
              参数值
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.paramKey || '-'}}
              </vs-td>
              <vs-td>
                {{tr.paramValue}}
              </vs-td>
              <vs-td>
                {{tr.remark || '-'}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:config:update')"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:config:delete')"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
   <add-config-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-config-dialog>
      <edit-config-dialog
       :form-data="formData"
       :dialog-show="editDialogShow"
       @close="closeEditDialog"
       @add-success="editUserSuccess"
     ></edit-config-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editConfigDialog from '@/components/sys/config/editConfigDialog'
import addConfigDialog from "@/components/sys/config/addConfigDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import {deleteConfig} from "@/api/sys/config/config";
export default {
  name: "index",
  components: {
    addConfigDialog,
    editConfigDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      paramKey: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      formData: {},
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  created(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/config/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc'
      }

      if(this.paramKey){
        this.params.paramKey = this.paramKey;
      }
      return true;
    },
    addHandle(){
      this.addDialogShow = true;
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.formData = row;
      this.editDialogShow = true;
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteConfig(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.config-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
